import { FC } from 'react';

import { NavigationWithQuery } from '@telialt/core-navigation/src/components/NavigationWithQuery';

export const NavBar: FC = () => {
    return <NavigationWithQuery />;
};
